import { ComponentRef, Injectable, Injector } from '@angular/core';
import { Overlay, OverlayConfig, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { PpLoaderComponent } from '@penpencil/forms';

export class LoadingOverlayRef {
    constructor(private overlayRef: OverlayRef) {}

    close(): void {
        this.overlayRef.dispose();
    }
}

@Injectable({
    providedIn: 'root',
})
export class LoadingService {
    constructor(private overlay: Overlay) {}

    open(): LoadingOverlayRef {
        const overlayRef = this.createOverlay();
        const dialogRef = new LoadingOverlayRef(overlayRef);
        this.attachDialogContainer(overlayRef);

        return dialogRef;
    }

    private createOverlay(): OverlayRef {
        const positionStrategy = this.overlay
            .position()
            .global()
            .centerHorizontally()
            .centerVertically();
        const overlayConfig = new OverlayConfig({
            hasBackdrop: true,
            scrollStrategy: this.overlay.scrollStrategies.block(),
            positionStrategy,
        });

        return this.overlay.create(overlayConfig);
    }

    private attachDialogContainer(overlayRef: OverlayRef): PpLoaderComponent {
        const injector = Injector.create({
            providers: [{ provide: LoadingOverlayRef, deps: [] }],
        });
        const containerPortal = new ComponentPortal(
            PpLoaderComponent,
            null,
            injector,
        );
        const containerRef: ComponentRef<PpLoaderComponent> =
            overlayRef.attach(containerPortal);

        return containerRef.instance;
    }
}
